import React, { useEffect } from 'react';

import { ScanType, ShareType } from 'generated/types';

interface ScanResultState {
  is_initialized: boolean;
  is_sharing: boolean;
  scan_type?: ScanType;
  share_scan_type?: ShareType;
}

interface IContext {
  state: ScanResultState;
}

const initialState: ScanResultState = {
  is_initialized: false,
  is_sharing: false,
  scan_type: undefined,
  share_scan_type: undefined,
};

const reducer = (
  state: ScanResultState,
  updates: Partial<ScanResultState>
) => ({
  ...state,
  ...updates,
});

const Context = React.createContext<IContext>({
  state: initialState,
});
Context.displayName = 'ScanResultContext';

const Provider: React.FC<{
  children: React.ReactNode;
  scanType?: string;
  isSharing?: boolean;
}> = ({ children = null, scanType, isSharing }) => {
  const [state, dispatch] = React.useReducer(reducer, {
    ...initialState,
  });

  useEffect(() => {
    let scan_type;
    let share_scan_type;

    if (scanType === 'cough-scan-history') {
      scan_type = ScanType.respiratory;
      share_scan_type = ShareType.CoughScans;
    } else if (scanType === 'skin-scan-history') {
      scan_type = ScanType.skin;
      share_scan_type = ShareType.SkinScans;
    } else if (scanType === 'body-scan-history') {
      scan_type = ScanType.body;
      share_scan_type = ShareType.BodyScans;
    } else if (scanType === 'face-scan-history') {
      scan_type = ScanType.face;
      share_scan_type = ShareType.FaceScans;
    }
    dispatch({
      is_initialized: true,
      is_sharing: isSharing,
      scan_type,
      share_scan_type,
    });
  }, [isSharing, scanType]);

  const value: IContext = React.useMemo(
    () => ({
      state,
      dispatch,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );

  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export {
  // Actions as ScanResultActions,
  Context as ScanResultContext,
  Provider as ScanResultProvider,
};
export type { ScanResultState, IContext as IScanResultContext };
